import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSVGIcon from 'vue-svgicon'
import VueFlashMessage from 'vue-flash-message';


Vue.config.productionTip = false


Vue.use(VueSVGIcon, {
  tagName: 'svg-icon'
});

Vue.use(VueFlashMessage);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
